import { $api } from "../AxiosInstance";

export class MetadataService {
  // Meta Date
  static async getMetaDate() {
    return await $api.get("/api/admin/metaDate/all");
  }

  static async getMetaDateByLocale() {
    return await $api.get("/api/admin/metaDate/all/groupBy/locale");
  }

  static async getMetaDateById(id) {
    return await $api.get("/api/admin/metaDate", { params: { id } });
  }

  static async createMetaDate(attribute, language, value) {
    return await $api.put("/api/admin/metaDate", {
      attribute,
      language,
      value,
    });
  }

  static async saveMetaDate(id, attribute, language, value) {
    return await $api.post("/api/admin/metaDate", {
      id,
      attribute,
      language,
      value,
    });
  }

  static async deleteMetaDate(id) {
    return await $api.delete("/api/admin/metaDate", { params: { id } });
  }

  // Tips
  static async getTips() {
    return await $api.get("/api/admin/tips/all/groupBy/locale");
  }

  static async changeTipsOrder(tipsSortedIds) {
    return await $api.post("/api/admin/tips/changeIndices", {
      tipsSortedIds,
    });
  }

  static async getTipsById(id) {
    return await $api.get("/api/admin/tips", { params: { id } });
  }

  static async createTips(params) {
    return await $api.put("/api/admin/tips", params);
  }

  static async saveTips(params) {
    return await $api.post("/api/admin/tips", params);
  }

  static async deleteTips(id) {
    return await $api.delete("/api/admin/tips", { params: { id } });
  }

  // Advantages
  static async getAdvantages() {
    return await $api.get("/api/admin/advantages/all/groupBy/locale");
  }

  static async getAdvantagesById(id) {
    return await $api.get("/api/admin/advantages", { params: { id } });
  }

  static async saveAdvantages(params) {
    return await $api.post("/api/admin/advantages", params);
  }

  static async changeAdvantagesOrder(advantagesSortedIds) {
    return await $api.post("/api/admin/advantages/changeIndices", {
      advantagesSortedIds,
    });
  }

  static async createAdvantages(params) {
    return await $api.put("/api/admin/advantages", params);
  }

  static async deleteAdvantages(id) {
    return await $api.delete("/api/admin/advantages", { params: { id } });
  }
}
